import * as t from 'io-ts';
import { EntityStatus } from '../entity-status.type';

const SupplierMdfQualificationStatusDto = t.intersection(
  [
    EntityStatus,
    t.type({
      isFullyMatch: t.boolean,
    }),
  ],
  'SupplierMdfQualificationStatusDto',
);

type SupplierMdfQualificationStatusDto = t.TypeOf<
  typeof SupplierMdfQualificationStatusDto
>;

export { SupplierMdfQualificationStatusDto };
